"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Version = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Version = function Version() {
  _classCallCheck(this, Version);
}; // export class Version {
// private _rules: [[], string, string[], (payload) => string] = []
// [开始时间，结束时间], 
// public define(['', ''], tag, subTags, ) {
// }
// tag 
// public match(tag, subTag) {
// }
// }
// export class Version {
//     constructor() {
//     }
//     public defineRaw(version, tags, ) {
//     }
//     public match([tags], payload) {
//     }
// }
// version.define('')
// version.match(payload, () => {
// })


exports.Version = Version;


//////////////////
// WEBPACK FOOTER
// ./~/@weike/toolkit/lib/version/version.js
// module id = 590
// module chunks = 6